(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("APlayer", [], factory);
	else if(typeof exports === 'object')
		exports["APlayer"] = factory();
	else
		root["APlayer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    } else {
        return Array.from(arr);
    }
}
var isMobile = /mobile/i.test(window.navigator.userAgent);
var utils = {
    secondToTime: function secondToTime(second) {
        var add0 = function add0(num) {
            return num < 10 ? '0' + num : '' + num;
        };
        var hour = Math.floor(second / 3600);
        var min = Math.floor((second - hour * 3600) / 60);
        var sec = Math.floor(second - hour * 3600 - min * 60);
        return (hour > 0 ? [
            hour,
            min,
            sec
        ] : [
            min,
            sec
        ]).map(add0).join(':');
    },
    getElementViewLeft: function getElementViewLeft(element) {
        var actualLeft = element.offsetLeft;
        var current = element.offsetParent;
        var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        } else {
            while (current !== null && current !== element) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        }
        return actualLeft - elementScrollLeft;
    },
    getElementViewTop: function getElementViewTop(element) {
        var actualTop = element.offsetTop;
        var current = element.offsetParent;
        var elementScrollTop = 0;
        while (current !== null) {
            actualTop += current.offsetTop;
            current = current.offsetParent;
        }
        elementScrollTop = document.body.scrollTop + document.documentElement.scrollTop;
        return actualTop - elementScrollTop;
    },
    isMobile: isMobile,
    storage: {
        set: function set(key, value) {
            localStorage.setItem(key, value);
        },
        get: function get(key) {
            return localStorage.getItem(key);
        }
    },
    nameMap: {
        dragStart: isMobile ? 'touchstart' : 'mousedown',
        dragMove: isMobile ? 'touchmove' : 'mousemove',
        dragEnd: isMobile ? 'touchend' : 'mouseup'
    },
    randomOrder: function randomOrder() {
        var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined.options.audio.length;
        function shuffle(arr) {
            for (var i = arr.length - 1; i >= 0; i--) {
                var randomIndex = Math.floor(Math.random() * (i + 1));
                var itemAtIndex = arr[randomIndex];
                arr[randomIndex] = arr[i];
                arr[i] = itemAtIndex;
            }
            return arr;
        }
        return shuffle([].concat(_toConsumableArray(Array(length))).map(function (item, i) {
            return i;
        }));
    }
};
exports.default = utils;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var g;
g = function () {
    return this;
}();
try {
    g = g || Function('return this')() || (1, eval)('this');
} catch (e) {
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object')
        g = window;
}
module.exports = g;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _play = __webpack_require__(11);
var _play2 = _interopRequireDefault(_play);
var _pause = __webpack_require__(12);
var _pause2 = _interopRequireDefault(_pause);
var _volumeUp = __webpack_require__(13);
var _volumeUp2 = _interopRequireDefault(_volumeUp);
var _volumeDown = __webpack_require__(14);
var _volumeDown2 = _interopRequireDefault(_volumeDown);
var _volumeOff = __webpack_require__(15);
var _volumeOff2 = _interopRequireDefault(_volumeOff);
var _orderRandom = __webpack_require__(16);
var _orderRandom2 = _interopRequireDefault(_orderRandom);
var _orderList = __webpack_require__(17);
var _orderList2 = _interopRequireDefault(_orderList);
var _menu = __webpack_require__(18);
var _menu2 = _interopRequireDefault(_menu);
var _loopAll = __webpack_require__(19);
var _loopAll2 = _interopRequireDefault(_loopAll);
var _loopOne = __webpack_require__(20);
var _loopOne2 = _interopRequireDefault(_loopOne);
var _loopNone = __webpack_require__(21);
var _loopNone2 = _interopRequireDefault(_loopNone);
var _loading = __webpack_require__(22);
var _loading2 = _interopRequireDefault(_loading);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
var Icons = {
    play: _play2.default,
    pause: _pause2.default,
    volumeUp: _volumeUp2.default,
    volumeDown: _volumeDown2.default,
    volumeOff: _volumeOff2.default,
    orderRandom: _orderRandom2.default,
    orderList: _orderList2.default,
    menu: _menu2.default,
    loopAll: _loopAll2.default,
    loopOne: _loopOne2.default,
    loopNone: _loopNone2.default,
    loading: _loading2.default
};
exports.default = Icons;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(26);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
__webpack_require__(5);
var _player = __webpack_require__(6);
var _player2 = _interopRequireDefault(_player);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
console.log('\n' + ' %c APlayer v' + "1.7.0" + ' ' + "375c0f7" + ' %c http://aplayer.js.org ' + '\n' + '\n', 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
exports.default = _player2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _promisePolyfill = __webpack_require__(7);
var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
var _icons = __webpack_require__(2);
var _icons2 = _interopRequireDefault(_icons);
var _options = __webpack_require__(23);
var _options2 = _interopRequireDefault(_options);
var _template = __webpack_require__(24);
var _template2 = _interopRequireDefault(_template);
var _bar = __webpack_require__(28);
var _bar2 = _interopRequireDefault(_bar);
var _user = __webpack_require__(29);
var _user2 = _interopRequireDefault(_user);
var _lrc = __webpack_require__(30);
var _lrc2 = _interopRequireDefault(_lrc);
var _controller = __webpack_require__(32);
var _controller2 = _interopRequireDefault(_controller);
var _timer = __webpack_require__(33);
var _timer2 = _interopRequireDefault(_timer);
var _events = __webpack_require__(34);
var _events2 = _interopRequireDefault(_events);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var instances = [];
var APlayer = function () {
    function APlayer(options) {
        _classCallCheck(this, APlayer);
        this.options = (0, _options2.default)(options);
        this.container = this.options.container;
        this.playIndex = 0;
        this.paused = true;
        this.playedPromise = _promisePolyfill2.default.resolve();
        this.randomOrder = _utils2.default.randomOrder(this.options.audio.length);
        this.container.classList.add('aplayer');
        if (this.options.lrc) {
            this.container.classList.add('aplayer-withlrc');
        }
        if (this.options.audio.length > 1) {
            this.container.classList.add('aplayer-withlist');
        }
        if (_utils2.default.isMobile) {
            this.container.classList.add('aplayer-mobile');
        }
        this.arrow = this.container.offsetWidth <= 300;
        if (this.arrow) {
            this.container.classList.add('aplayer-arrow');
        }
        if (this.options.mini) {
            this.container.classList.add('aplayer-narrow');
        }
        this.container = this.options.container;
        if (this.options.lrc === 2 || this.options.lrc === true) {
            var lrcEle = this.container.getElementsByClassName('aplayer-lrc-content');
            for (var i = 0; i < lrcEle.length; i++) {
                if (this.options.audio[i]) {
                    this.options.audio[i].lrc = lrcEle[i].innerHTML;
                }
            }
        }
        this.template = new _template2.default({
            container: this.container,
            options: this.options,
            randomOrder: this.randomOrder
        });
        if (this.template.info.offsetWidth < 200) {
            this.template.time.classList.add('aplayer-time-narrow');
        }
        if (this.options.lrc) {
            this.lrc = new _lrc2.default({
                container: this.template.lrc,
                async: this.options.lrc === 3,
                content: this.options.audio.map(function (item) {
                    return item.lrc;
                }),
                player: this
            });
        }
        this.events = new _events2.default();
        this.user = new _user2.default(this);
        this.bar = new _bar2.default(this.template);
        this.controller = new _controller2.default(this);
        this.timer = new _timer2.default(this);
        this.initAudio();
        if (this.options.order === 'random') {
            this.switchAudio(this.randomOrder[0]);
        } else {
            this.switchAudio(0);
        }
        if (this.options.autoplay) {
            this.play();
        }
        instances.push(this);
    }
    _createClass(APlayer, [
        {
            key: 'initAudio',
            value: function initAudio() {
                var _this = this;
                this.audio = document.createElement('audio');
                this.audio.preload = this.options.preload;
                var _loop = function _loop(i) {
                    _this.audio.addEventListener(_this.events.audioEvents[i], function () {
                        _this.events.trigger(_this.events.audioEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.audioEvents.length; i++) {
                    _loop(i);
                }
                this.on('play', function () {
                    if (_this.paused) {
                        _this.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this.paused) {
                        _this.pause();
                    }
                });
                this.on('durationchange', function () {
                    if (_this.audio.duration !== 1) {
                        _this.template.dtime.innerHTML = _utils2.default.secondToTime(_this.audio.duration);
                    }
                });
                this.on('progress', function () {
                    var percentage = _this.audio.buffered.length ? _this.audio.buffered.end(_this.audio.buffered.length - 1) / _this.audio.duration : 0;
                    _this.bar.set('loaded', percentage, 'width');
                });
                this.on('error', function () {
                    _this.template.author.innerHTML = ' - Error happens \u2565﹏\u2565';
                });
                this.on('ended', function () {
                    if (_this.options.loop === 'none') {
                        if (_this.options.order === 'list') {
                            if (_this.playIndex < _this.options.audio.length - 1) {
                                _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                                _this.play();
                            } else {
                                _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                                _this.pause();
                            }
                        } else if (_this.options.order === 'random') {
                            if (_this.randomOrder.indexOf(_this.playIndex) < _this.randomOrder.length - 1) {
                                _this.switchAudio(_this.nextRandomNum());
                                _this.play();
                            } else {
                                _this.switchAudio(_this.nextRandomNum());
                                _this.pause();
                            }
                        }
                    } else if (_this.options.loop === 'one') {
                        _this.switchAudio(_this.playIndex);
                        _this.play();
                    } else if (_this.options.loop === 'all') {
                        if (_this.options.order === 'list') {
                            _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                        } else if (_this.options.order === 'random') {
                            _this.switchAudio(_this.nextRandomNum());
                        }
                        _this.play();
                    }
                });
                this.volume(this.user.get('volume'), true);
            }
        },
        {
            key: 'switchAudio',
            value: function switchAudio(index) {
                var _this2 = this;
                this.handlePlayPromise(function () {
                    _this2.events.trigger('switchaudio', index);
                    if (typeof index !== 'undefined') {
                        _this2.playIndex = index;
                    }
                    if (_this2.options.audio[_this2.playIndex].cover) {
                        _this2.template.pic.style.backgroundImage = 'url(\'' + _this2.options.audio[_this2.playIndex].cover + '\')';
                    } else {
                        _this2.template.pic.style.backgroundImage = '';
                    }
                    _this2.template.title.innerHTML = _this2.options.audio[_this2.playIndex].name;
                    _this2.template.author.innerHTML = _this2.options.audio[_this2.playIndex].artist ? ' - ' + _this2.options.audio[_this2.playIndex].artist : '';
                    var light = _this2.container.getElementsByClassName('aplayer-list-light')[0];
                    if (light) {
                        light.classList.remove('aplayer-list-light');
                    }
                    _this2.container.querySelectorAll('.aplayer-list li')[_this2.playIndex].classList.add('aplayer-list-light');
                    _this2.template.list.scrollTop = _this2.playIndex * 33;
                    _this2.audio.src = _this2.options.audio[_this2.playIndex].url;
                    _this2.seek(0);
                    var playPromise = void 0;
                    if (!_this2.paused) {
                        playPromise = _promisePolyfill2.default.resolve(_this2.audio.play()).catch(function (err) {
                            console.error(err);
                            _this2.pause();
                        });
                    }
                    _this2.lrc && _this2.lrc.switch(_this2.playIndex);
                    if (_this2.audio.duration !== 1) {
                        _this2.template.dtime.innerHTML = _this2.audio.duration ? _utils2.default.secondToTime(_this2.audio.duration) : '00:00';
                    }
                    return playPromise;
                });
            }
        },
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.audio.duration) {
                    time = Math.min(time, this.audio.duration);
                }
                this.audio.currentTime = time;
                if (isNaN(this.audio.duration)) {
                    this.bar.set('played', 0, 'width');
                } else {
                    this.bar.set('played', time / this.audio.duration, 'width');
                }
                this.template.ptime.innerHTML = _utils2.default.secondToTime(time);
            }
        },
        {
            key: 'play',
            value: function play() {
                var _this3 = this;
                this.handlePlayPromise(function () {
                    if (_this3.paused) {
                        _this3.paused = false;
                        _this3.template.button.classList.remove('aplayer-play');
                        _this3.template.button.classList.add('aplayer-pause');
                        _this3.template.button.innerHTML = '';
                        setTimeout(function () {
                            _this3.template.button.innerHTML = _icons2.default.pause;
                        }, 100);
                    }
                    var playPromise = _promisePolyfill2.default.resolve(_this3.audio.play()).catch(function (err) {
                        console.error(err);
                        _this3.pause();
                    });
                    _this3.timer.enable('loading');
                    _this3.timer.enable('progress');
                    if (_this3.options.mutex) {
                        for (var i = 0; i < instances.length; i++) {
                            if (_this3 !== instances[i]) {
                                instances[i].pause();
                            }
                        }
                    }
                    return playPromise;
                });
            }
        },
        {
            key: 'pause',
            value: function pause() {
                var _this4 = this;
                this.handlePlayPromise(function () {
                    if (!_this4.paused) {
                        _this4.paused = true;
                        _this4.template.button.classList.remove('aplayer-pause');
                        _this4.template.button.classList.add('aplayer-play');
                        _this4.template.button.innerHTML = '';
                        setTimeout(function () {
                            _this4.template.button.innerHTML = _icons2.default.play;
                        }, 100);
                    }
                    _this4.audio.pause();
                    _this4.timer.disable('loading');
                    _this4.timer.disable('progress');
                });
            }
        },
        {
            key: 'switchVolumeIcon',
            value: function switchVolumeIcon() {
                if (this.volume() >= 0.95) {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeUp;
                } else if (this.volume() > 0) {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeDown;
                } else {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeOff;
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nostorage) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    this.bar.set('volume', percentage, 'height');
                    if (!nostorage) {
                        this.user.set('volume', percentage);
                    }
                    this.audio.volume = percentage;
                    if (this.audio.muted) {
                        this.audio.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.audio.muted ? 0 : this.audio.volume;
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.template.button.classList.contains('aplayer-play')) {
                    this.play();
                } else if (this.template.button.classList.contains('aplayer-pause')) {
                    this.pause();
                }
            }
        },
        {
            key: 'isMultiple',
            value: function isMultiple() {
                return this.options.audio.length > 1;
            }
        },
        {
            key: 'nextRandomNum',
            value: function nextRandomNum() {
                if (this.isMultiple()) {
                    var index = this.randomOrder.indexOf(this.playIndex);
                    if (index === this.randomOrder.length - 1) {
                        return this.randomOrder[0];
                    } else {
                        return this.randomOrder[index + 1];
                    }
                } else {
                    return 0;
                }
            }
        },
        {
            key: 'addAudio',
            value: function addAudio(newMusic) {
                this.events.trigger('addaudio', newMusic);
                var wasSingle = !this.isMultiple();
                this.options.audio = this.options.audio.concat(newMusic);
                var newItemHTML = '';
                for (var i = 0; i < newMusic.length; i++) {
                    newItemHTML += '<li><span class="aplayer-list-cur" style="background: ' + this.options.theme + ';"></span><span class="aplayer-list-index">' + (this.options.audio.length - newMusic.length + i + 1) + '</span><span class="aplayer-list-title">' + newMusic[i].name + '</span><span class="aplayer-list-author">' + newMusic[i].artist + '</span></li>';
                }
                this.template.listOl.innerHTML += newItemHTML;
                if (wasSingle && this.isMultiple()) {
                    this.container.classList.add('aplayer-withlist');
                    this.audio.loop = false;
                }
                var songListLength = this.container.querySelectorAll('.aplayer-list li').length;
                this.template.list.style.height = songListLength * 33 - 1 + 'px';
                this.randomOrder = _utils2.default.randomOrder(this.options.audio.length);
            }
        },
        {
            key: 'removeAudio',
            value: function removeAudio(index) {
                this.events.trigger('removeaudio', index);
                if (this.options.audio[index] && this.options.audio.length > 1) {
                    var list = this.container.querySelectorAll('.aplayer-list li');
                    this.options.audio.splice(index, 1);
                    if (index === this.playIndex) {
                        if (this.options.audio[index + 1]) {
                            this.switchAudio(index);
                        } else {
                            this.switchAudio(index - 1);
                        }
                    }
                    if (this.playIndex > index) {
                        this.playIndex--;
                    }
                    list[index].remove();
                    for (var i = index; i < list.length; i++) {
                        list[i].getElementsByClassName('aplayer-list-index')[0].textContent = i;
                    }
                    if (this.options.audio.length === 1) {
                        this.container.classList.remove('aplayer-withlist');
                    }
                    this.template.list.style.height = parseInt(this.template.list.style.height, 10) - 33 + 'px';
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                this.container.innerHTML = '';
                this.audio.src = '';
                this.timer.destroy();
                this.events.trigger('destroy');
            }
        },
        {
            key: 'handlePlayPromise',
            value: function handlePlayPromise(callback) {
                this.playedPromise = this.playedPromise.then(callback).catch(function (err) {
                    console.error(err);
                });
            }
        }
    ]);
    return APlayer;
}();
exports.default = APlayer;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {
var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var setTimeoutFunc = setTimeout;
function noop() {
}
function bind(fn, thisArg) {
    return function () {
        fn.apply(thisArg, arguments);
    };
}
function Promise(fn) {
    if (!(this instanceof Promise))
        throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function')
        throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];
    doResolve(fn, this);
}
function handle(self, deferred) {
    while (self._state === 3) {
        self = self._value;
    }
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            reject(deferred.promise, e);
            return;
        }
        resolve(deferred.promise, ret);
    });
}
function resolve(self, newValue) {
    try {
        if (newValue === self)
            throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof Promise) {
                self._state = 3;
                self._value = newValue;
                finale(self);
                return;
            } else if (typeof then === 'function') {
                doResolve(bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        finale(self);
    } catch (e) {
        reject(self, e);
    }
}
function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
}
function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
        Promise._immediateFn(function () {
            if (!self._handled) {
                Promise._unhandledRejectionFn(self._value);
            }
        });
    }
    for (var i = 0, len = self._deferreds.length; i < len; i++) {
        handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
}
function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
function doResolve(fn, self) {
    var done = false;
    try {
        fn(function (value) {
            if (done)
                return;
            done = true;
            resolve(self, value);
        }, function (reason) {
            if (done)
                return;
            done = true;
            reject(self, reason);
        });
    } catch (ex) {
        if (done)
            return;
        done = true;
        reject(self, ex);
    }
}
Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);
    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
};
Promise.prototype['finally'] = function (callback) {
    var constructor = this.constructor;
    return this.then(function (value) {
        return constructor.resolve(callback()).then(function () {
            return value;
        });
    }, function (reason) {
        return constructor.resolve(callback()).then(function () {
            return constructor.reject(reason);
        });
    });
};
Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
        if (!arr || typeof arr.length === 'undefined')
            throw new TypeError('Promise.all accepts an array');
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0)
            return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function (val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) {
                    resolve(args);
                }
            } catch (ex) {
                reject(ex);
            }
        }
        for (var i = 0; i < args.length; i++) {
            res(i, args[i]);
        }
    });
};
Promise.resolve = function (value) {
    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
        return value;
    }
    return new Promise(function (resolve) {
        resolve(value);
    });
};
Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
        reject(value);
    });
};
Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
        for (var i = 0, len = values.length; i < len; i++) {
            values[i].then(resolve, reject);
        }
    });
};
Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
} || function (fn) {
    setTimeoutFunc(fn, 0);
};
Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
        console.warn('Possible Unhandled Promise Rejection:', err);
    }
};
module.exports = Promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).setImmediate))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = Function.prototype.apply;
exports.setTimeout = function () {
    return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function () {
    return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
    if (timeout) {
        timeout.close();
    }
};
function Timeout(id, clearFn) {
    this._id = id;
    this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {
};
Timeout.prototype.close = function () {
    this._clearFn.call(window, this._id);
};
exports.enroll = function (item, msecs) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = msecs;
};
exports.unenroll = function (item) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = -1;
};
exports._unrefActive = exports.active = function (item) {
    clearTimeout(item._idleTimeoutId);
    var msecs = item._idleTimeout;
    if (msecs >= 0) {
        item._idleTimeoutId = setTimeout(function onTimeout() {
            if (item._onTimeout)
                item._onTimeout();
        }, msecs);
    }
};
__webpack_require__(9);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {
(function (global, undefined) {
    'use strict';
    if (global.setImmediate) {
        return;
    }
    var nextHandle = 1;
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;
    function setImmediate(callback) {
        if (typeof callback !== 'function') {
            callback = new Function('' + callback);
        }
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }
    function runIfPresent(handle) {
        if (currentlyRunningATask) {
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage('', '*');
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        var messagePrefix = 'setImmediate$' + Math.random() + '$';
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        if (global.addEventListener) {
            global.addEventListener('message', onGlobalMessage, false);
        } else {
            global.attachEvent('onmessage', onGlobalMessage);
        }
        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, '*');
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
    if ({}.toString.call(global.process) === '[object process]') {
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        installMessageChannelImplementation();
    } else if (doc && 'onreadystatechange' in doc.createElement('script')) {
        installReadyStateChangeImplementation();
    } else {
        installSetTimeoutImplementation();
    }
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === 'undefined' ? typeof global === 'undefined' ? undefined : global : self));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(10)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var process = module.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
}());
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        return setTimeout(fun, 0);
    }
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        return clearTimeout(marker);
    }
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}
function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = '';
process.versions = {};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function (name) {
    return [];
};
process.binding = function (name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 16 31\"><path d=\"M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z\"></path></svg>"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 17 32\"><path d=\"M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z\"></path></svg>"

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 28 32\"><path d=\"M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056zM29.728 16q0 4.096-2.272 7.552t-6.048 5.056q-0.224 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.64 0.704-1.056 0.128-0.064 0.384-0.192t0.416-0.192q0.8-0.448 1.44-0.896 2.208-1.632 3.456-4.064t1.216-5.152-1.216-5.152-3.456-4.064q-0.64-0.448-1.44-0.896-0.128-0.096-0.416-0.192t-0.384-0.192q-0.704-0.416-0.704-1.056 0-0.448 0.32-0.8t0.832-0.352q0.224 0 0.448 0.096 3.776 1.632 6.048 5.056t2.272 7.552z\"></path></svg>"

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 28 32\"><path d=\"M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z\"></path></svg>"

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 28 32\"><path d=\"M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z\"></path></svg>"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\"><path d=\"M22.667 4l7 6-7 6 7 6-7 6v-4h-3.653l-3.76-3.76 2.827-2.827 2.587 2.587h2v-8h-2l-12 12h-6v-4h4.347l12-12h3.653v-4zM2.667 8h6l3.76 3.76-2.827 2.827-2.587-2.587h-4.347v-4z\"></path></svg>"

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\"><path d=\"M0.622 18.334h19.54v7.55l11.052-9.412-11.052-9.413v7.549h-19.54v3.725z\"></path></svg>"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 22 32\"><path d=\"M20.8 14.4q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2zM1.6 11.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2zM20.8 20.8q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2z\"></path></svg>"

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 29 32\"><path d=\"M9.333 9.333h13.333v4l5.333-5.333-5.333-5.333v4h-16v8h2.667v-5.333zM22.667 22.667h-13.333v-4l-5.333 5.333 5.333 5.333v-4h16v-8h-2.667v5.333z\"></path></svg>"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 33 32\"><path d=\"M9.333 9.333h13.333v4l5.333-5.333-5.333-5.333v4h-16v8h2.667v-5.333zM22.667 22.667h-13.333v-4l-5.333 5.333 5.333 5.333v-4h16v-8h-2.667v5.333zM17.333 20v-8h-1.333l-2.667 1.333v1.333h2v5.333h2z\"></path></svg>"

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 29 32\"><path d=\"M2.667 7.027l1.707-1.693 22.293 22.293-1.693 1.707-4-4h-11.64v4l-5.333-5.333 5.333-5.333v4h8.973l-8.973-8.973v0.973h-2.667v-3.64l-4-4zM22.667 17.333h2.667v5.573l-2.667-2.667v-2.907zM22.667 6.667v-4l5.333 5.333-5.333 5.333v-4h-10.907l-2.667-2.667h13.573z\"></path></svg>"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\"><path d=\"M4 16c0-6.6 5.4-12 12-12s12 5.4 12 12c0 1.2-0.8 2-2 2s-2-0.8-2-2c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.2 0 2 0.8 2 2s-0.8 2-2 2c-6.6 0-12-5.4-12-12z\"></path></svg>"

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
exports.default = function (options) {
    var defaultOption = {
        container: options.element || document.getElementsByClassName('aplayer')[0],
        mini: options.narrow || false,
        autoplay: false,
        mutex: true,
        lrc: options.showlrc || 0,
        preload: 'auto',
        theme: '#b7daff',
        loop: 'all',
        order: 'list',
        volume: 0.7,
        listFolded: false,
        listMaxHeight: options.listmaxheight,
        audio: options.music
    };
    for (var defaultKey in defaultOption) {
        if (defaultOption.hasOwnProperty(defaultKey) && !options.hasOwnProperty(defaultKey)) {
            options[defaultKey] = defaultOption[defaultKey];
        }
    }
    if (Object.prototype.toString.call(options.audio) !== '[object Array]') {
        options.audio = [options.audio];
    }
    options.audio.map(function (item) {
        item.name = item.name || item.title;
        item.artist = item.artist || item.author;
        item.cover = item.cover || item.pic;
        return item;
    });
    if (options.audio.length <= 1 && options.loop === 'one') {
        options.loop = 'all';
    }
    return options;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _icons = __webpack_require__(2);
var _icons2 = _interopRequireDefault(_icons);
var _player = __webpack_require__(25);
var _player2 = _interopRequireDefault(_player);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Template = function () {
    function Template(options) {
        _classCallCheck(this, Template);
        this.container = options.container;
        this.options = options.options;
        this.randomOrder = options.randomOrder;
        this.init();
    }
    _createClass(Template, [{
            key: 'init',
            value: function init() {
                var cover = void 0;
                if (this.options.order === 'random') {
                    cover = this.options.audio[this.randomOrder[0]].cover;
                } else {
                    cover = this.options.audio[0].cover;
                }
                this.container.innerHTML = (0, _player2.default)({
                    options: this.options,
                    icons: _icons2.default,
                    cover: cover
                });
                this.lrc = this.container.querySelector('.aplayer-lrc-contents');
                this.ptime = this.container.querySelector('.aplayer-ptime');
                this.info = this.container.querySelector('.aplayer-info');
                this.time = this.container.querySelector('.aplayer-time');
                this.barWrap = this.container.querySelector('.aplayer-bar-wrap');
                this.button = this.container.querySelector('.aplayer-button');
                this.list = this.container.querySelector('.aplayer-list');
                this.listOl = this.container.querySelector('.aplayer-list ol');
                this.played = this.container.querySelector('.aplayer-played');
                this.loaded = this.container.querySelector('.aplayer-loaded');
                this.thumb = this.container.querySelector('.aplayer-thumb');
                this.volume = this.container.querySelector('.aplayer-volume');
                this.volumeBar = this.container.querySelector('.aplayer-volume-bar');
                this.volumeButton = this.container.querySelector('.aplayer-time button');
                this.volumeBarWrap = this.container.querySelector('.aplayer-volume-bar-wrap');
                this.loop = this.container.querySelector('.aplayer-icon-loop');
                this.order = this.container.querySelector('.aplayer-icon-order');
                this.menu = this.container.querySelector('.aplayer-icon-menu');
                this.pic = this.container.querySelector('.aplayer-pic');
                this.title = this.container.querySelector('.aplayer-title');
                this.author = this.container.querySelector('.aplayer-author');
                this.dtime = this.container.querySelector('.aplayer-dtime');
            }
        }]);
    return Template;
}();
exports.default = Template;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var $imports = __webpack_require__(3);
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', cover = $data.cover, $escape = $imports.$escape, icons = $data.icons, options = $data.options, $each = $imports.$each, $value = $data.$value, $index = $data.$index;
    $$out += '<div class="aplayer-pic"';
    if (cover) {
        $$out += ' style="background-image: url("';
        $$out += $escape(cover);
        $$out += '");"';
    }
    $$out += '>\n    <div class="aplayer-button aplayer-play">';
    $$out += icons.play;
    $$out += '</div>\n</div>\n<div class="aplayer-info">\n    <div class="aplayer-music">\n        <span class="aplayer-title"></span>\n        <span class="aplayer-author"></span>\n    </div>\n    <div class="aplayer-lrc">\n        <div class="aplayer-lrc-contents" style="transform: translateY(0); -webkit-transform: translateY(0);"></div>\n    </div>\n    <div class="aplayer-controller">\n        <div class="aplayer-bar-wrap">\n            <div class="aplayer-bar">\n                <div class="aplayer-loaded" style="width: 0"></div>\n                <div class="aplayer-played" style="width: 0; background: ';
    $$out += $escape(options.theme);
    $$out += ';">\n                    <span class="aplayer-thumb" style="background: ';
    $$out += $escape(options.theme);
    $$out += ';">\n                        <span class="aplayer-loading-icon">';
    $$out += icons.loading;
    $$out += '</span>\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div class="aplayer-time">\n            <span class="aplayer-time-inner">\n                - <span class="aplayer-ptime">00:00</span> / <span class="aplayer-dtime">00:00</span>\n            </span>\n            <div class="aplayer-volume-wrap">\n                <button type="button" class="aplayer-icon aplayer-icon-volume-down">\n                    ';
    $$out += icons.volumeDown;
    $$out += '\n                </button>\n                <div class="aplayer-volume-bar-wrap">\n                    <div class="aplayer-volume-bar">\n                        <div class="aplayer-volume" style="height: 80%; background: ';
    $$out += $escape(options.theme);
    $$out += ';"></div>\n                    </div>\n                </div>\n            </div>\n            ';
    if (options.audio.length > 1) {
        $$out += '\n            <button type="button" class="aplayer-icon aplayer-icon-order">\n                ';
        if (options.order === 'list') {
            $$out += icons.orderList;
        } else if (options.order === 'random') {
            $$out += icons.orderRandom;
        }
        $$out += '\n            </button>\n            ';
    }
    $$out += '\n            <button type="button" class="aplayer-icon aplayer-icon-loop">\n                ';
    if (options.loop === 'one') {
        $$out += icons.loopOne;
    } else if (options.loop === 'all') {
        $$out += icons.loopAll;
    } else if (options.loop === 'none') {
        $$out += icons.loopNone;
    }
    $$out += '\n            </button>\n            <button type="button" class="aplayer-icon aplayer-icon-menu">\n                ';
    $$out += icons.menu;
    $$out += '\n            </button>\n        </div>\n    </div>\n</div>\n<div class="aplayer-list';
    if (options.listFolded) {
        $$out += ' aplayer-list-hide';
    }
    $$out += '"';
    if (options.listMaxHeight) {
        $$out += ' style="max-height: ';
        $$out += $escape(options.listMaxHeight);
        $$out += '"';
    }
    $$out += '>\n    <ol>\n        ';
    $each(options.audio, function ($value, $index) {
        $$out += '\n        <li>\n            <span class="aplayer-list-cur" style="background: ';
        $$out += $escape(options.theme);
        $$out += ';"></span>\n            <span class="aplayer-list-index">';
        $$out += $escape($index + 1);
        $$out += '</span>\n            <span class="aplayer-list-title">';
        $$out += $escape($value.name);
        $$out += '</span>\n            <span class="aplayer-list-author">';
        $$out += $escape($value.artist);
        $$out += '</span>\n        </li>\n        ';
    });
    $$out += '\n    </ol>\n</div>';
    return $$out;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var detectNode = __webpack_require__(27);
var runtime = Object.create(detectNode ? global : window);
var ESCAPE_REG = /["&'<>]/;
runtime.$escape = function (content) {
    return xmlEscape(toString(content));
};
runtime.$each = function (data, callback) {
    if (Array.isArray(data)) {
        for (var i = 0, len = data.length; i < len; i++) {
            callback(data[i], i);
        }
    } else {
        for (var _i in data) {
            callback(data[_i], _i);
        }
    }
};
function toString(value) {
    if (typeof value !== 'string') {
        if (value === undefined || value === null) {
            value = '';
        } else if (typeof value === 'function') {
            value = toString(value.call(value));
        } else {
            value = JSON.stringify(value);
        }
    }
    return value;
}
;
function xmlEscape(content) {
    var html = '' + content;
    var regexResult = ESCAPE_REG.exec(html);
    if (!regexResult) {
        return content;
    }
    var result = '';
    var i = void 0, lastIndex = void 0, char = void 0;
    for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
        switch (html.charCodeAt(i)) {
        case 34:
            char = '&#34;';
            break;
        case 38:
            char = '&#38;';
            break;
        case 39:
            char = '&#39;';
            break;
        case 60:
            char = '&#60;';
            break;
        case 62:
            char = '&#62;';
            break;
        default:
            continue;
        }
        if (lastIndex !== i) {
            result += html.substring(lastIndex, i);
        }
        lastIndex = i + 1;
        result += char;
    }
    if (lastIndex !== i) {
        return result + html.substring(lastIndex, i);
    } else {
        return result;
    }
}
;
module.exports = runtime;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
module.exports = false;
try {
    module.exports = Object.prototype.toString.call(global.process) === '[object process]';
} catch (e) {
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Bar = function () {
    function Bar(template) {
        _classCallCheck(this, Bar);
        this.elements = {};
        this.elements.volume = template.volume;
        this.elements.played = template.played;
        this.elements.loaded = template.loaded;
    }
    _createClass(Bar, [
        {
            key: 'set',
            value: function set(type, percentage, direction) {
                percentage = Math.max(percentage, 0);
                percentage = Math.min(percentage, 1);
                this.elements[type].style[direction] = percentage * 100 + '%';
            }
        },
        {
            key: 'get',
            value: function get(type, direction) {
                return parseFloat(this.elements[type].style[direction]) / 100;
            }
        }
    ]);
    return Bar;
}();
exports.default = Bar;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var User = function () {
    function User(player) {
        _classCallCheck(this, User);
        this.storageName = { volume: 'aplayer-volume' };
        this.default = { volume: player.options.volume || 0.7 };
        this.data = {};
        this.init();
    }
    _createClass(User, [
        {
            key: 'init',
            value: function init() {
                for (var item in this.storageName) {
                    var name = this.storageName[item];
                    this.data[item] = parseFloat(_utils2.default.storage.get(name) || this.default[item]);
                }
            }
        },
        {
            key: 'get',
            value: function get(key) {
                return this.data[key];
            }
        },
        {
            key: 'set',
            value: function set(key, value) {
                this.data[key] = value;
                _utils2.default.storage.set(this.storageName[key], value);
            }
        }
    ]);
    return User;
}();
exports.default = User;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _lrc = __webpack_require__(31);
var _lrc2 = _interopRequireDefault(_lrc);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Lrc = function () {
    function Lrc(options) {
        _classCallCheck(this, Lrc);
        this.container = options.container;
        this.async = options.async;
        this.player = options.player;
        this.content = options.content;
        this.parsed = [];
        this.index = 0;
        this.current = [];
    }
    _createClass(Lrc, [
        {
            key: 'update',
            value: function update() {
                var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.player.audio.currentTime;
                if (this.index > this.current.length - 1 || currentTime < this.current[this.index][0] || !this.current[this.index + 1] || currentTime >= this.current[this.index + 1][0]) {
                    for (var i = 0; i < this.current.length; i++) {
                        if (currentTime >= this.current[i][0] && (!this.current[i + 1] || currentTime < this.current[i + 1][0])) {
                            this.index = i;
                            this.container.style.transform = 'translateY(' + -this.index * 16 + 'px)';
                            this.container.style.webkitTransform = 'translateY(' + -this.index * 16 + 'px)';
                            this.container.getElementsByClassName('aplayer-lrc-current')[0].classList.remove('aplayer-lrc-current');
                            this.container.getElementsByTagName('p')[i].classList.add('aplayer-lrc-current');
                        }
                    }
                }
            }
        },
        {
            key: 'switch',
            value: function _switch(index) {
                var _this = this;
                if (!this.parsed[index]) {
                    if (!this.async) {
                        if (this.content[index]) {
                            this.parsed[index] = this.parse(this.content[index]);
                        } else {
                            this.parsed[index] = [[
                                    '00:00',
                                    'Not available'
                                ]];
                        }
                    } else {
                        this.parsed[index] = [[
                                '00:00',
                                'Loading'
                            ]];
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === 4) {
                                if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                                    _this.parsed[index] = _this.parse(xhr.responseText);
                                } else {
                                    console.log('Request was unsuccessful: ' + xhr.status);
                                    _this.parsed[index] = [[
                                            '00:00',
                                            'Not available'
                                        ]];
                                }
                                _this.container.innerHTML = (0, _lrc2.default)({ lyrics: _this.parsed[index] });
                                _this.update(0);
                                _this.current = _this.parsed[index];
                            }
                        };
                        var apiurl = this.content[index];
                        xhr.open('get', apiurl, true);
                        xhr.send(null);
                    }
                }
                this.container.innerHTML = (0, _lrc2.default)({ lyrics: this.parsed[index] });
                this.update(0);
                this.current = this.parsed[index];
            }
        },
        {
            key: 'parse',
            value: function parse(lrc_s) {
                if (lrc_s) {
                    lrc_s = lrc_s.replace(/([^\]^\n])\[/g, function (match, p1) {
                        return p1 + '\n[';
                    });
                    var lyric = lrc_s.split('\n');
                    var lrc = [];
                    var lyricLen = lyric.length;
                    for (var i = 0; i < lyricLen; i++) {
                        var lrcTimes = lyric[i].match(/\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g);
                        var lrcText = lyric[i].replace(/.*\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g, '').replace(/<(\d{2}):(\d{2})(\.(\d{2,3}))?>/g, '').replace(/^\s+|\s+$/g, '');
                        if (lrcTimes) {
                            var timeLen = lrcTimes.length;
                            for (var j = 0; j < timeLen; j++) {
                                var oneTime = /\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/.exec(lrcTimes[j]);
                                var min2sec = oneTime[1] * 60;
                                var sec2sec = parseInt(oneTime[2]);
                                var msec2sec = oneTime[4] ? parseInt(oneTime[4]) / ((oneTime[4] + '').length === 2 ? 100 : 1000) : 0;
                                var lrcTime = min2sec + sec2sec + msec2sec;
                                lrc.push([
                                    lrcTime,
                                    lrcText
                                ]);
                            }
                        }
                    }
                    lrc.sort(function (a, b) {
                        return a[0] - b[0];
                    });
                    return lrc;
                } else {
                    return [];
                }
            }
        }
    ]);
    return Lrc;
}();
exports.default = Lrc;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var $imports = __webpack_require__(3);
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $each = $imports.$each, lyrics = $data.lyrics, $value = $data.$value, $index = $data.$index, $escape = $imports.$escape;
    $each(lyrics, function ($value, $index) {
        $$out += '\n    <p';
        if ($index === 0) {
            $$out += ' class="aplayer-lrc-current"';
        }
        $$out += '>';
        $$out += $escape($value[1]);
        $$out += '</p>\n';
    });
    return $$out;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
var _icons = __webpack_require__(2);
var _icons2 = _interopRequireDefault(_icons);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Controller = function () {
    function Controller(player) {
        _classCallCheck(this, Controller);
        this.player = player;
        this.initPlayButton();
        this.initList();
        this.initPlayBar();
        if (this.player.isMultiple()) {
            this.initOrderButton();
        }
        this.initLoopButton();
        this.initMenuButton();
        if (!_utils2.default.isMobile) {
            this.initVolumeButton();
        }
    }
    _createClass(Controller, [
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this = this;
                this.player.template.pic.addEventListener('click', function () {
                    _this.player.toggle();
                });
            }
        },
        {
            key: 'initList',
            value: function initList() {
                var _this2 = this;
                this.player.template.list.addEventListener('click', function (e) {
                    var target = void 0;
                    if (e.target.tagName.toUpperCase() === 'LI') {
                        target = e.target;
                    } else {
                        target = e.target.parentElement;
                    }
                    var audioIndex = parseInt(target.getElementsByClassName('aplayer-list-index')[0].innerHTML) - 1;
                    if (audioIndex !== _this2.player.playIndex) {
                        _this2.player.switchAudio(audioIndex);
                        _this2.player.play();
                    } else {
                        _this2.player.toggle();
                    }
                });
            }
        },
        {
            key: 'initPlayBar',
            value: function initPlayBar() {
                var _this3 = this;
                var thumbMove = function thumbMove(e) {
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _utils2.default.getElementViewLeft(_this3.player.template.barWrap)) / _this3.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.bar.set('played', percentage, 'width');
                    _this3.player.lrc && _this3.player.lrc.update(percentage * _this3.player.audio.duration);
                    _this3.player.template.ptime.innerHTML = _utils2.default.secondToTime(percentage * _this3.player.audio.duration);
                };
                var thumbUp = function thumbUp(e) {
                    document.removeEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _utils2.default.getElementViewLeft(_this3.player.template.barWrap)) / _this3.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.bar.set('played', percentage, 'width');
                    _this3.player.seek(_this3.player.bar.get('played', 'width') * _this3.player.audio.duration);
                    _this3.player.timer.enable('progress');
                };
                this.player.template.barWrap.addEventListener(_utils2.default.nameMap.dragStart, function () {
                    _this3.player.timer.disable('progress');
                    document.addEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    document.addEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this4 = this;
                this.player.template.volumeButton.addEventListener('click', function () {
                    if (_this4.player.audio.muted) {
                        _this4.player.audio.muted = false;
                        _this4.player.switchVolumeIcon();
                        _this4.player.bar.set('volume', _this4.player.volume(), 'height');
                    } else {
                        _this4.player.audio.muted = true;
                        _this4.player.switchVolumeIcon();
                        _this4.player.bar.set('volume', 0, 'height');
                    }
                });
                var thumbMove = function thumbMove(e) {
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _utils2.default.getElementViewTop(_this4.player.template.volumeBar)) / _this4.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.volume(percentage);
                };
                var thumbUp = function thumbUp(e) {
                    _this4.player.template.volumeBarWrap.classList.remove('aplayer-volume-bar-wrap-active');
                    document.removeEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _utils2.default.getElementViewTop(_this4.player.template.volumeBar)) / _this4.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.volume(percentage);
                };
                this.player.template.volumeBarWrap.addEventListener(_utils2.default.nameMap.dragStart, function () {
                    _this4.player.template.volumeBarWrap.classList.add('aplayer-volume-bar-wrap-active');
                    document.addEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    document.addEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initOrderButton',
            value: function initOrderButton() {
                var _this5 = this;
                this.player.template.order.addEventListener('click', function () {
                    if (_this5.player.options.order === 'list') {
                        _this5.player.options.order = 'random';
                        _this5.player.template.order.innerHTML = _icons2.default.orderRandom;
                    } else if (_this5.player.options.order === 'random') {
                        _this5.player.options.order = 'list';
                        _this5.player.template.order.innerHTML = _icons2.default.orderList;
                    }
                });
            }
        },
        {
            key: 'initLoopButton',
            value: function initLoopButton() {
                var _this6 = this;
                this.player.template.loop.addEventListener('click', function () {
                    if (_this6.player.isMultiple()) {
                        if (_this6.player.options.loop === 'one') {
                            _this6.player.options.loop = 'none';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopNone;
                        } else if (_this6.player.options.loop === 'none') {
                            _this6.player.options.loop = 'all';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopAll;
                        } else if (_this6.player.options.loop === 'all') {
                            _this6.player.options.loop = 'one';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopOne;
                        }
                    } else {
                        if (_this6.player.options.loop === 'one' || _this6.player.options.loop === 'all') {
                            _this6.player.options.loop = 'none';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopNone;
                        } else if (_this6.player.options.loop === 'none') {
                            _this6.player.options.loop = 'all';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopAll;
                        }
                    }
                });
            }
        },
        {
            key: 'initMenuButton',
            value: function initMenuButton() {
                var _this7 = this;
                this.player.template.list.style.height = 33 * this.player.options.audio.length - 1 + 'px';
                this.player.template.menu.addEventListener('click', function () {
                    if (!_this7.player.template.list.classList.contains('aplayer-list-hide')) {
                        _this7.player.template.list.classList.add('aplayer-list-hide');
                    } else {
                        _this7.player.template.list.classList.remove('aplayer-list-hide');
                    }
                });
            }
        }
    ]);
    return Controller;
}();
exports.default = Controller;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Timer = function () {
    function Timer(player) {
        _classCallCheck(this, Timer);
        this.player = player;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        this.types = [
            'loading',
            'progress'
        ];
        this.init();
    }
    _createClass(Timer, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.types.map(function (item) {
                    _this['init' + item + 'Checker']();
                    return item;
                });
            }
        },
        {
            key: 'initprogressChecker',
            value: function initprogressChecker() {
                var _this2 = this;
                this.progressChecker = setInterval(function () {
                    if (_this2.enableprogressChecker) {
                        _this2.player.bar.set('played', _this2.player.audio.currentTime / _this2.player.audio.duration, 'width');
                        _this2.player.lrc && _this2.player.lrc.update();
                        var currentTime = _utils2.default.secondToTime(_this2.player.audio.currentTime);
                        if (_this2.player.template.ptime.innerHTML !== currentTime) {
                            _this2.player.template.ptime.innerHTML = currentTime;
                        }
                    }
                }, 100);
            }
        },
        {
            key: 'initloadingChecker',
            value: function initloadingChecker() {
                var _this3 = this;
                var lastPlayPos = 0;
                var currentPlayPos = 0;
                var bufferingDetected = false;
                this.loadingChecker = setInterval(function () {
                    if (_this3.enableloadingChecker) {
                        currentPlayPos = _this3.player.audio.currentTime;
                        if (!bufferingDetected && currentPlayPos === lastPlayPos && !_this3.player.audio.paused) {
                            _this3.player.container.classList.add('aplayer-loading');
                            bufferingDetected = true;
                        }
                        if (bufferingDetected && currentPlayPos > lastPlayPos && !_this3.player.audio.paused) {
                            _this3.player.container.classList.remove('aplayer-loading');
                            bufferingDetected = false;
                        }
                        lastPlayPos = currentPlayPos;
                    }
                }, 100);
            }
        },
        {
            key: 'enable',
            value: function enable(type) {
                this['enable' + type + 'Checker'] = true;
                if (type === 'fps') {
                    this.initfpsChecker();
                }
            }
        },
        {
            key: 'disable',
            value: function disable(type) {
                this['enable' + type + 'Checker'] = false;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this4 = this;
                this.types.map(function (item) {
                    _this4['enable' + item + 'Checker'] = false;
                    _this4[item + 'Checker'] && clearInterval(_this4[item + 'Checker']);
                    return item;
                });
            }
        }
    ]);
    return Timer;
}();
exports.default = Timer;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Events = function () {
    function Events() {
        _classCallCheck(this, Events);
        this.events = {};
        this.audioEvents = [
            'abort',
            'canplay',
            'canplaythrough',
            'durationchange',
            'emptied',
            'ended',
            'error',
            'loadeddata',
            'loadedmetadata',
            'loadstart',
            'mozaudioavailable',
            'pause',
            'play',
            'playing',
            'progress',
            'ratechange',
            'seeked',
            'seeking',
            'stalled',
            'suspend',
            'timeupdate',
            'volumechange',
            'waiting'
        ];
        this.playerEvents = [
            'destroy',
            'switchaudio',
            'addaudio',
            'removeaudio'
        ];
    }
    _createClass(Events, [
        {
            key: 'on',
            value: function on(name, callback) {
                if (this.type(name) && typeof callback === 'function') {
                    if (!this.events[name]) {
                        this.events[name] = [];
                    }
                    this.events[name].push(callback);
                }
            }
        },
        {
            key: 'trigger',
            value: function trigger(name, info) {
                if (this.events[name] && this.events[name].length) {
                    for (var i = 0; i < this.events[name].length; i++) {
                        this.events[name][i](info);
                    }
                }
            }
        },
        {
            key: 'type',
            value: function type(name) {
                if (this.playerEvents.indexOf(name) !== -1) {
                    return 'player';
                } else if (this.audioEvents.indexOf(name) !== -1) {
                    return 'audio';
                }
                console.error('Unknown event name: ' + name);
                return null;
            }
        }
    ]);
    return Events;
}();
exports.default = Events;

/***/ })
/******/ ])["default"];
});


// WEBPACK FOOTER //
// APlayer.min.js